import * as React from 'react'
import { IanimationTimerProps } from '../types/index'

import { KeravaRadarButton } from '../elements/button'

import styled from '../theme/styled'

const Wrapper = styled.div`
  width: 100px;
  }
`

class AnimationTimer extends React.Component<IanimationTimerProps, any> {
  constructor(props: IanimationTimerProps) {
    super(props)

    this.state = { timer: undefined, interval: 1500 }

  }
  public componentDidUpdate(prevProps: IanimationTimerProps) {
    if (prevProps.snapshot !== this.props.snapshot && this.props.animationId !== 0) {
      this.props.resetId()
    }
    if (this.props.snapshot[this.props.view].length > 11 && prevProps.snapshot[this.props.view] !== this.props.snapshot[this.props.view]) {
      this.props.startTimer()
    }
    if (prevProps.timer !== this.props.timer && this.props.timer) {
      this.startTimeInterval()
    }
    if (prevProps.timer !== this.props.timer && !this.props.timer) {
      this.stopTimeInterval()
    }
  }

  // interval is for animating the snapshots
  public startTimeInterval = (): void => {
    if (this.state.timer) {
      clearInterval(this.state.timer)
    }
    this.setState({
      timer: setInterval(
        () => {
          if (this.props.animationId >= this.props.snapshot[this.props.view].length - 1) {
            this.props.resetId()
          } else {
            this.props.incrementId()
          }
        },
        this.state.interval
      )
    })
  }

  public stopTimeInterval = (): void => {
    clearInterval(this.state.timer)
    this.setState({
      timer: undefined
    })
  }

  render() {
    return (
      <Wrapper>
        {
          this.props.timer ?
            <KeravaRadarButton width="100%" onClick={this.props.stopTimer}>
              stop
            </KeravaRadarButton> :
            <KeravaRadarButton width="100%" onClick={this.props.startTimer}>
              start
            </KeravaRadarButton>
        }
      </Wrapper>
    )
  }
}

export default AnimationTimer



// WEBPACK FOOTER //
// ./src/components/AnimationTimer.tsx